import { Grid, Stack, styled, Typography } from "@mui/material";
import PrimaryButton from "components/button/PrimaryButton";
import FlexBetween from "components/flexbox/FlexBetween";
import { motion, useInView } from "framer-motion";
import { useRef } from "react";

const Section = styled("section")(({ theme }) => ({}));

export const Section6 = () => {
  const innerHeight = window.innerHeight;
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: false,
    margin: `${-innerHeight / 4}px`,
  });

  return (
    <Section
      ref={ref}
      sx={{
        position: "relative",
        scrollSnapAlign: "center",
      }}
    >
      <Stack
        spacing={{ xs: 0, md: 5 }}
        sx={{ height: "100%", width: "100%", px: { xs: 3, md: 20 } }}
        alignItems={"center"}
        justifyContent={"center"}
      >
        <FlexBetween gap={30}>
          <Stack sx={{ display: { xs: "none", xmd: "block" } }}>
            <motion.img
              src="static/svg/machine.svg"
              style={{ height: "45vh" }}
              initial={{
                transform: "scale(3) translateY(-50px)",
                opacity: 0,
                filter: "blur(40px)",
              }}
              animate={{
                transform: `scale(${isInView ? 1 : 3}) translateY(-${isInView ? 0 : 50
                  }px)`,
                opacity: isInView ? 1 : 0,
                filter: `blur(${isInView ? 0 : 40}px)`,
              }}
              transition={{
                delay: 0.2,
              }}
            />
          </Stack>
          <Stack spacing={3}>
            <motion.div
              initial={{
                transform: `translateX(50vw) scaleY(0)`,
                opacity: 0,
              }}
              animate={{
                transform: `translateX(${isInView ? 0 : 50}vw) scaleY(${isInView ? 1 : 0
                  })`,
                opacity: isInView ? 1 : 0,
              }}
              transition={{
                type: "spring",
                stiffness: 700,
                damping: 30,
                delay: 0.6,
              }}
            >
              <Typography
                sx={{
                  textTransform: "uppercase",
                  fontWeight: 700,
                  fontSize: { xs: 24, md: 28, lg: 32 },
                  textAlign: { xs: "center", xmd: "left" },
                }}
              >
                $18.95B MARGIN liquidity waiting for you
              </Typography>
            </motion.div>
            <motion.div
              style={{ width: "100%" }}
              initial={{
                transform: `translateX(50vw) scaleY(0)`,
                opacity: 0,
              }}
              animate={{
                transform: `translateX(${isInView ? 0 : 50}vw) scaleY(${isInView ? 1 : 0
                  })`,
                opacity: isInView ? 1 : 0,
              }}
              transition={{
                type: "spring",
                stiffness: 700,
                damping: 40,
                delay: 0.7,
              }}
            >
              <Typography
                sx={{
                  fontWeight: { xs: 500, xmd: 400 },
                  fontSize: { xs: 12, xmd: 24 },
                  textAlign: { xs: "center", xmd: "left" },
                }}
              >
                Recently, 44,935 users have deposited $18.95 billion into AAVE,
                generating a yield of approximately 5-6% APY for USDC. This
                sustainable model provides a large and secure margin of
                liquidity for traders.
              </Typography>
            </motion.div>
            <motion.div
              initial={{
                y: 20,
                opacity: 0,
              }}
              animate={{ y: isInView ? 0 : 20, opacity: isInView ? 1 : 0 }}
              transition={{ duration: 0.2, delay: 0.9 }}
            >
              <PrimaryButton
                onClick={() => window.open('https://app.flaex.io/trading', '_blank')}
                sx={{
                  background: "linear-gradient(90deg,#AA3AF6,#FDA9E5)",
                  color: "#000",
                  fontWeight: 700,
                  margin: { xs: "auto", xmd: "unset" },
                }}
              >
                TRADE NOW
              </PrimaryButton>
            </motion.div>
          </Stack>
        </FlexBetween>
        {isInView && (
          <Grid
            container
            columns={175}
            justifyContent={"center"}
            flexDirection={{ xs: "column", xmd: "row" }}
          >
            <Grid
              item
              xs={175}
              sx={{ display: { xs: "block", xmd: "none" } }}
            ></Grid>
            <Grid
              container
              columns={175}
              justifyContent={"center"}
              flexDirection={{ xs: "column", xmd: "row" }}
              height={{ xs: "auto", xmd: "unset" }}
            >
              <Grid
                item
                xs={40}
                textAlign={"center"}
                py={1.5}
                maxWidth={{ xs: "unset", xmd: "auto" }}
              >
                <motion.div
                  initial={{
                    transform: "translateX(-100px)",
                    opacity: 0,
                  }}
                  animate={{
                    transform: `translateX(${isInView ? 0 : -100}px)`,
                    opacity: isInView ? 1 : 0,
                  }}
                  transition={{
                    delay: 1.2,
                  }}
                >
                  <Typography textTransform={"uppercase"} fontWeight={700}>
                    DEVnet Launch
                  </Typography>
                  <Typography variant="caption">Building Product</Typography>
                  <Typography>2023</Typography>
                </motion.div>
              </Grid>
              <Grid
                item
                xs={40}
                textAlign={"center"}
                py={1.5}
                maxWidth={{ xs: "unset", xmd: "auto" }}
              >
                <motion.div
                  initial={{
                    transform: "translateX(-100px)",
                    opacity: 0,
                  }}
                  animate={{
                    transform: `translateX(${isInView ? 0 : -100}px)`,
                    opacity: isInView ? 1 : 0,
                  }}
                  transition={{
                    delay: 1.4,
                  }}
                >
                  <Typography textTransform={"uppercase"} fontWeight={700}>
                    testnet Launch
                  </Typography>
                  <Typography variant="caption">Initial Airdrop</Typography>
                  <Typography>2024</Typography>
                </motion.div>
              </Grid>
              <Grid
                item
                xs={40}
                textAlign={"center"}
                py={1.5}
                maxWidth={{ xs: "unset", xmd: "auto" }}
              >
                <motion.div
                  initial={{
                    transform: "translateX(-100px)",
                    opacity: 0,
                  }}
                  animate={{
                    transform: `translateX(${isInView ? 0 : -100}px)`,
                    opacity: isInView ? 1 : 0,
                  }}
                  transition={{
                    delay: 1.6,
                  }}
                >
                  <Typography textTransform={"uppercase"} fontWeight={700}>
                    mainet launch
                  </Typography>
                  <Typography variant="caption">Redemption</Typography>
                  <Typography>2025</Typography>
                </motion.div>
              </Grid>
              <Grid item xs={175} display={{ xs: "none", xmd: "block" }}>
                <motion.img
                  src="static/svg/line.svg"
                  style={{ width: "100%", height: "auto" }}
                  initial={{ opacity: 0 }}
                  animate={{
                    opacity: isInView ? 1 : 0,
                  }}
                  transition={{ delay: 1 }}
                />
              </Grid>
            </Grid>
          </Grid>
        )}
      </Stack>
    </Section>
  );
};
